import SpineSymbol from 'core/display/spines/SpineSymbol'
import { reelsSettings } from 'settings/custom/reels'
import { create, replace, replaceSkin } from 'utils/Object'

import Symbol from './Symbol'

export default class SymbolSkin extends Symbol {
  constructor(id, settings) {
    super(id, settings)
  }
  createSymbol(id) {
    super.createSymbol(id)
  }

  createSpine(id){
    const { win, items, skins } = this.settings
    if (skins.symbol.includes(id)){
      skins.symbol.forEach((symbol, index) => {
        if (symbol === id) {
          const newItems = { skin: skins.skin[index], ...items }
          this._spine = new SpineSymbol(create(newItems, replaceSkin(skins.path, 'spine', id)))
        }
      } )
    }
    else{
      this._spine = new SpineSymbol(create(items, replace(win, 'spine', id)))
    }
    this._spine.scale.set(this._scale)
    this._spine.visible  = true
    this._spine.stop()
    this.addChild(this._spine)
    if(reelsSettings.hasOwnProperty('overSymbols')){
      const overSymbols = reelsSettings.overSymbols
      overSymbols.symbol.forEach((symbol, index) => {
        if(symbol === id){
          this._sprite.x = overSymbols.parameter.spine[index].x
          this._sprite.y = overSymbols.parameter.spine[index].y
        }
      },
      )
    }
  }
}
